import {HttpHandler} from "../../../utils/handler/HttpHandler";
import {HttpHandlerLegacy} from "../../../utils/handler/HttpHandlerLegacy";
import {LENDER, BORROWER} from "../../../utils/constants/Constants";

export class BilateralBidService {
    constructor(){
        this.httpHandler = new HttpHandler();
        this.httpHandlerLegacy = new HttpHandlerLegacy();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral');
        this.axiosInstanceLegacy = this.httpHandlerLegacy.createInstance('/appapv');
    }
    /**
     * Función que hace una llamada al back para consultar la lista para
     * llenar la pantalla de prostura administrativa bilateral bilateral.
     * @returns {Promise<any>} Respuesta que contiene la lista de
     * posturas administrativas o regresa un error, cuando no puede consultar.
     */
    getBilateralBidAdmin(source) {
        return this.axiosInstance({
            url: '/bid/admin',
            method: 'get',
            params: {
                source: source
            }
        }).then(res => res);
    }

    getCatalogInstitutions(institutionType) {
        return this.axiosInstance({
            url: '/contract/' + institutionType + '/institutions',
            method: 'get',
        }).then(res => res);
    }

    getLenderCounterparts(lenderId){
        return this.axiosInstance({
            url: '/contract/lender/' + lenderId + '/counterparts',
            method: 'get'
        }).then(res => res);
    }

    getBorrowerCounterparts(borrowerId){
        return this.axiosInstance({
            url: '/contract/borrower/' + borrowerId + '/counterparts',
            method: 'get'
        }).then(res => res);
    }

    getCatalogInstrument(effectiveFiltered) {
        let effectiveFilter = effectiveFiltered !== undefined ?
             effectiveFiltered ? 1 : 0 : 0;
        return this.axiosInstanceLegacy({
            url: '/getNotExpiredInstrumentsBilateralView.action',
            method: 'get',
            params: {
                effectiveFiltered: effectiveFilter
            }
        }).then(res => res
        );
    }

    addLenderOrderAdmin(bidRequestData){
        return this.axiosInstance({
            url: '/bid/' + LENDER + '/admin/create',
            method: 'post',
            data: bidRequestData
        }).then(res => res);
    }

    addBorrowerOrderAdmin(bidRequestData){
        return this.axiosInstance({
            url: '/bid/' +  BORROWER + '/admin/create',
            method: 'post',
            data: bidRequestData
        }).then(res => res);
    }

}